import React, { useEffect, useState } from 'react';
import { getCookie, setCookie } from './lib'

import {useUser} from './api/user_api'
import {FullPageSpinner} from './lib'
import {useGlobalState} from "./context/global-context"


//import {useUser} from './context/user-context'
//import {FullPageSpinner} from './components/lib'

//import 'bootstrap/dist/css/bootstrap.min.css'

import './App.scss';
import './styles/table-pretty.scss'
import './styles/spinner.scss';


//import './styles/table-pretty.scss'
//const loadAuthenticatedApp = () => import('./authenticated-app');
//const AuthenticatedApp = React.lazy(loadAuthenticatedApp);

const AuthenticatedApp = React.lazy(() => import('./authenticated-app'));
//const UnauthenticatedApp = React.lazy(() => import('./unauthenticated-app'));

const UnAuthenticatedApp = React.lazy(() => import('./unauthenticated-app'));

function App() {
  const globalState  = useGlobalState();
  //  const user = useUser()
  // pre-load the authenticated side in the background while the user's
  // filling out the login form.
  const [authenticated, setAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const { user } = useUser();
  useEffect(() => {
    document.getElementById("spinner-handler").style.visibility ="hidden"

    //setCookie('secret','',1)
    let secret = getCookie("secret")
    if (!secret || secret ==='') {
      setAuthenticated(false);
      setIsLoading(false);
    } else {
      user.login_secret(secret)
      .success(userData => {
        userData = userData[0];
        if (userData) {
          setAuthenticated(true);
          setIsLoading(false);
          globalState.party_code = userData.party_code;
          globalState.party_name = userData.companyname;
        }  else {
          setAuthenticated(false);
          setIsLoading(false);
        } 
      }).error((err) => {
        setAuthenticated(false);
      }) 
    }
  }, []);

  function handleAuth () {
      setAuthenticated(true);
  }

  function logout(){
    setCookie("secret","",-999999999999)
    setAuthenticated(false);
  }

// <React.Suspense fallback={<FullPageSpinner />}>  
//{user ? <AuthenticatedApp /> : <UnauthenticatedApp />}
//</React.Suspense>
  return (
    <React.Suspense fallback={<FullPageSpinner />}> 
    <div id="spinner-handler">
      <FullPageSpinner/>
    </div>
    <div className="">
      {isLoading ? <FullPageSpinner /> : authenticated ? <AuthenticatedApp logout={logout}/> : <UnAuthenticatedApp handleAuth={handleAuth}/> }
    </div> 
    </React.Suspense>
  )
}

export default App

